import editFormClient from "../edit-form-client/index.vue";
import { mapActions } from "vuex";
export default {
    props: ["client"],
    name: "list-client",
    components: {
        editFormClient,
    },
    data() {
        return {
            isEdit: false,
        };
    },
    methods: {
        ...mapActions({
            fetchAgentClients: `profile/GET_AGENT_CLIENTS`,
            deleteAgentClient: `profile/REMOVE_AGENT_CLIENT`,
        }),
        closeEdit() {
            this.isEdit = false;
        },
        removeClient(client) {
            let obj = {};
            obj.id = client.id;
            this.deleteAgentClient(obj)
                .then(() => {
                    this.$toasted.success(this.$t("youClientRemove"));
                    this.fetchAgentClients();
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        console.log(error.response);
                    }
                });
        },
    },
};
